import { FormattedCurrency } from "../../../../shared/component/FormattedCurrency";
import { SumColumnProps } from "./summaryDetailsTableConsts";

export const SumColumn = ({ field, value }: SumColumnProps) => {
  switch (field) {
    case "totalAmount":
      return <FormattedCurrency value={value.totalAmount} currency='VND' />;
    case "amountWithoutVAT":
      return (
        <FormattedCurrency value={value.totalAmountWithoutVAT} currency='VND' />
      );
    case "vatAmount":
      return <FormattedCurrency value={value.totalVatAmount} currency='VND' />;
    default:
      return <div className=''></div>;
  }
};
